import script from "./describe-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./describe-item.vue?vue&type=script&setup=true&lang=ts"

import "./describe-item.vue?vue&type=style&index=0&id=5cd3d1c0&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cd3d1c0"]])

export default __exports__